import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/service-subscriptions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/service-subscriptions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = (studentId, feeSetupId) => {
  return httpClient
    .get(`/api/service-subscriptions/${studentId}/${feeSetupId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  destroy
}
